async function readFileEntry(entry: FileSystemFileEntry): Promise<File> {
    return new Promise<File>((resolve, reject): any => {
        entry.file(resolve, reject);
    });
}

// ----------------------------------------------------------------------------

export default readFileEntry;
